module.exports = __webpack_public_path__ + "static/media/Fichier 23.b630bace.svg";